import { SftpPushPendingRecordsTableColumnKeys } from "../../../../enums/tableColumnKeys";
import { SftpPushPendingRecordsTableDataModel } from "../hooks/useSftpPushPending";

export const toggleCheckboxSelection = (
  id: string,
  setTableData: React.Dispatch<
    React.SetStateAction<SftpPushPendingRecordsTableDataModel[]>
  >,
) => {
  setTableData((prevData) =>
    prevData.map((row) => {
      if (row[SftpPushPendingRecordsTableColumnKeys.SELECT]?.id === id) {
        return {
          ...row,
          [SftpPushPendingRecordsTableColumnKeys.SELECT]: {
            ...row[SftpPushPendingRecordsTableColumnKeys.SELECT],
            isChecked:
              !row[SftpPushPendingRecordsTableColumnKeys.SELECT].isChecked,
          },
        };
      }
      return row;
    }),
  );
};
